/** Reuse unchanged JSON data. Shared history/result branches stop at identity. */
export function shareUnchanged<T>(previous: T, next: T): T {
  if (Object.is(previous, next)) return previous;
  if (!previous || !next || typeof previous !== 'object' || typeof next !== 'object' || Array.isArray(previous) !== Array.isArray(next)) return next;
  const old = previous as Record<string, unknown>, value = next as Record<string, unknown>;
  const keys = Object.keys(value);
  let equal = keys.length === Object.keys(old).length;
  const result: Record<string, unknown> = Array.isArray(next) ? [] as unknown as Record<string, unknown> : {};
  for (const key of keys) {
    result[key] = shareUnchanged(old[key], value[key]);
    if (!Object.hasOwn(old, key) || result[key] !== old[key]) equal = false;
  }
  return equal ? previous : result as T;
}

const versions = new WeakMap<object, number>();
let serial = 0;
export function identityVersion(value: object): number {
  let version = versions.get(value);
  if (version === undefined) { version = ++serial; versions.set(value, version); }
  return version;
}
